import { TSoftwareFunctions } from '../../../types/index'
import SoftwareFeatureScroll from './SoftwareFeatureScroll'
import SoftwareFeatureScrollMobile from './SoftwareFeatureScrollMobile'

type SoftwareFeatureSectionProps = Pick<
    TSoftwareFunctions,
    | 'step1Label' | 'step1Headline'
    | 'step2Label' | 'step2Headline'
    | 'logoText' | 'labelSidebar' | 'bottomTextSidebar'
    | 'coreFunctions' | 'extensions'
>

export default function SoftwareFeatureSection(props: SoftwareFeatureSectionProps) {
    return (
        <>
            <SoftwareFeatureScroll {...props} />
            <SoftwareFeatureScrollMobile {...props} />
        </>
    )
}